/**
 * Branding Configuration for LifeFlo AI
 * Trust, Calm, Clarity, Premium
 * Update these values for your custom branding
 */

export const BRANDING = {
  // Logo URLs
  logo: {
    // LifeFlo AI logo
    main: '/assets/lifeflo-logo-new.png',
    
    // Logo for light backgrounds
    light: '/assets/lifeflo-logo-new.png',
    
    // Logo for dark backgrounds
    dark: '/assets/lifeflo-logo-new.png',
    
    // Small icon/favicon
    icon: '/assets/lifeflo-logo-new.png',
  },

  // App Information
  app: {
    name: 'LifeFlo AI',
    tagline: 'Health + Work + Life + AI',
    description: 'Manage your work, health, and life with intelligent AI assistance',
    url: 'https://lifeflo.ai', // Update with your domain
  },

  // Company Information
  company: {
    name: 'LifeFlo AI',
    email: 'hello@lifeflo.ai',
    support: 'support@lifeflo.ai',
    privacy: 'privacy@lifeflo.ai',
  },

  // Social Links (Optional)
  social: {
    twitter: 'https://twitter.com/yourhandle',
    linkedin: 'https://linkedin.com/company/yourcompany',
    facebook: 'https://facebook.com/yourpage',
  },

  // Colors - LifeFlo Brand Colors
  // Trust, Calm, Clarity, Premium
  colors: {
    primary: '#2FB9B3',    // Soft Teal - main brand
    secondary: '#3A4F7A',  // Deep Indigo - AI accent
    accent: '#6EDBC8',     // Fresh Mint - action/CTA
    emotional: '#F28C8C',  // Soft Coral - life mode
    work: '#5B6E8C',       // Slate Blue - work mode
    health: '#6EDBC8',     // Mint Green - health mode
    background: '#F7F9F8', // Off-White background
  },
  
  // Mode colors for visual distinction
  modes: {
    home: '#2FB9B3',    // Soft Teal
    chat: '#3A4F7A',    // Deep Indigo (AI)
    health: '#6EDBC8',  // Mint Green
    work: '#5B6E8C',    // Slate Blue
    life: '#F28C8C',    // Soft Coral
  },
};

// Helper function to get logo URL
export const getLogo = (variant = 'main') => {
  return BRANDING.logo[variant] || BRANDING.logo.main;
};

// Helper function to get app info
export const getAppInfo = () => {
  return BRANDING.app;
};

export default BRANDING;
